import React, { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import MainScreen from './pages/MainScreen';
import Casino from './pages/Casino';
import ApolloProvider from './providers/ApolloProvider';
import './App.css';
import Game from './pages/Game';
import ResponsibleGambling from './pages/ResponsibleGambling';
import Bonuses from './pages/Bonuses';
import Vip from './pages/Vip';
import Profile from './pages/Profile';
import ProtectedRoute from './utils/ProtectedRoute';
import PaymentMethods from './pages/PaymentMethods';
import CashOut from './pages/Cashout';
import useMainStore from './store/mainState';
import { GET_ENVIRONMENTS, LABELS_BY_ENVIRONMENT } from './graphql/games';
import { useQuery } from '@apollo/client';
import SBOSport from './pages/SBOSport';
import GGSport from './pages/GGSport';
import Favorites from './pages/Favorites';
import Raffle from './pages/Raffle';
import Support from './pages/Support';
import Toast from './components/ui/base/Toast';


const Pages = () => {
  const { pathname } = useLocation();


  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);
  return (<div className="App">
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<MainScreen />} />
        <Route path="casino" element={<Casino />} />
        <Route path="game" element={<Game />} />
        <Route path="responsible-gambling" element={<ResponsibleGambling />} />
        <Route path="bonus" element={
          <ProtectedRoute>
            <Bonuses />
          </ProtectedRoute>
        } />
        <Route path="payment" element={
          <ProtectedRoute>
            <PaymentMethods />
          </ProtectedRoute>
        } />
        {/* <Route path="cashout" element={
          <ProtectedRoute>
            <CashOut />
          </ProtectedRoute>
        } /> */}
        <Route path="vip" element={<Vip />} />
        <Route path="profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } />
        <Route path="sbo-sport" element={
          <ProtectedRoute>
            <SBOSport />
          </ProtectedRoute>
        } />
        <Route path="sport" element={
            <GGSport />
        } />
        <Route path="sbo-sport" element={
          <ProtectedRoute>
            <SBOSport />
          </ProtectedRoute>
        } />
        <Route path="favorites" element={
          <ProtectedRoute>
            <Favorites />
          </ProtectedRoute>
        } />
        <Route path="raffle" element={<Raffle />} />
        <Route path="support" element={
          <ProtectedRoute>
            <Support />
          </ProtectedRoute>
        } />
      </Route>
    </Routes>
  </div>)
}

function AppContent() {
  const { setEnvironment, environment, setLabelData, setUserCountry } = useMainStore();
  const { data: environmentsData, loading, error, refetch } = useQuery(GET_ENVIRONMENTS);
  const { data: labelsData } = useQuery(LABELS_BY_ENVIRONMENT, {
    variables: { environmentId: environment?.id },
    skip: !environment?.id,
    fetchPolicy: 'cache-first',
  });



  useLayoutEffect(() => {

    if (environmentsData) {
      const gg888Environment = environmentsData.environments.find((environment: any) => environment.host.includes('crackerjackpot'));
      if (gg888Environment) {
        setEnvironment(gg888Environment);
      }
    } else if (error) {
      refetch()
    }
  }, [environmentsData, setEnvironment]);

  useEffect(() => {

    if (labelsData) {
      setLabelData(labelsData.labelsByEnvironment[0]);
    }
  }, [labelsData, setLabelData]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch('https://ipapi.co/json/');
        if (!res.ok) return;
        const data = await res.json();
        const code = typeof data?.country_code === 'string' ? data.country_code.toUpperCase() : null;
        if (!cancelled && code) setUserCountry(code);
      } catch {
        // fail-open: leave userCountry null so games stay available
      }
    })();
    return () => { cancelled = true; };
  }, [setUserCountry]);



  return (
    !environment ? (
      <></>
    ) : (
      <Router>
        <Pages />
        <Toast />
      </Router>
    )
  );
}

function App() {
  return (
    <ApolloProvider>
      <AppContent />
    </ApolloProvider>
  );
}

export default App;
